import React, { useState } from 'react';
import { Option } from './quiztypes';

interface OptionProps {
	option: Option;
	isAnswered: boolean;
	onClick: (option: Option) => void;
}

const BizOption = ({ option, isAnswered, onClick }: OptionProps) => {
	const [containerStatusClass, setContainerStatus] = useState('one-option-container');
	const [resultClass, setResultClass] = useState('option-result');

	const clickHandler = () => {
		if (isAnswered) return;

		setContainerStatus('one-option-container show selected');
		if (option.IsCorrectAnswer) {
			setResultClass('option-result correct');
		} else {
			setResultClass('option-result wrong');
		}
		onClick(option);
	};

	return (
		<div className={containerStatusClass}>
			<div className='option-inner' onClick={clickHandler}>
				<div className='option-text'>
					<span>{option.Text}</span>
				</div>
				<div className={resultClass}>
					<span>{option.Text}</span>
					<i className='fa-solid fa-check correct-icon'></i>
					<i className='fa-solid fa-xmark-large wrong-icon'></i>
				</div>
			</div>
		</div>
	);
};

export default BizOption;
